// extracted by mini-css-extract-plugin
export default {"section":"SsF5a","sectionTitle":"r5Ycm","sectionLine":"ZPdIV","sectionLineValue":"KHEJU","sectionWithValue":"O2LjH","sectionLineDescription":"rg9T6"};